var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserConfirm',{attrs:{"title":_vm.title,"text":_vm.text,"cancel-button":false},on:{"ok":_vm.ok}})
}
var staticRenderFns = []

export { render, staticRenderFns }